import { useAppSelector } from 'app/hooks';
import { SubMenuGroup } from 'features/MenuBook/models';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import ChildSubMenuGroupRowList from '../ChildSubMenuGroupRowList';
import { getListStyle } from '../MenuBookEditorModal';
import SubMenuRow from '../SubMenuRow';

export interface SubMenuRowListProps {
  genreId: number;
  subgenreId: number;
  menuId: number;
  subMenuGroupId: number;
}

function SubMenuRowList({ genreId, subgenreId, menuId, subMenuGroupId }: SubMenuRowListProps) {
  const subMenuGroup = useAppSelector((state) => {
    return state.menuBookEditor.data
      .flatMap((genre) => (genre.id === genreId ? genre.subgenres : []))
      .flatMap((subgenre) => (subgenre.id === subgenreId ? subgenre.menus : []))
      .flatMap((menu) => (menu.id === menuId ? menu.sub_menu_groups : []))
      .find((subMenuGroup) => subMenuGroup.id === subMenuGroupId);
  }) as SubMenuGroup;

  const pathId = `${genreId}-${subgenreId}-${menuId}-${subMenuGroup.id}`;

  return (
    <Droppable droppableId={`sub_menu_group-${pathId}`} type={`sub_menu-${pathId}`}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {subMenuGroup.sub_menus.map((subMenu, index) => (
            <SubMenuRow
              key={`sub_menu-${pathId}-${subMenu.id}`}
              genreId={genreId}
              subgenreId={subgenreId}
              menuId={menuId}
              subMenuGroupId={subMenuGroup.id}
              subMenuId={subMenu.id}
              index={index}
            >
              <ChildSubMenuGroupRowList
                genreId={genreId}
                subgenreId={subgenreId}
                menuId={menuId}
                subMenuGroupId={subMenuGroupId}
                subMenuId={subMenu.id}
              />
            </SubMenuRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(SubMenuRowList);
